import { toVisibleMessagesArray } from 'modules/message/utils'
import { isEmpty, last, pathOr } from 'ramda'
import { useSelector } from 'react-redux'
import { ConversationId } from 'types/conversation'
import { Message } from 'types/message'

const useLastMessage = (conversationId: ConversationId): Partial<Message> => {
  const lastMessageFromConversation: Message = useSelector(state => (
    pathOr(null, ['conversations', 'conversations', conversationId, 'lastMessage'], state)
  ))

  const lastMessageFromMessages: Message = useSelector(state => {
    const messagesForActiveConversation = pathOr<Record<string, Message>>({}, ['conversations', 'messages', conversationId ], state)

    if (!isEmpty(messagesForActiveConversation)) {
      const agentMessagesForActiveConversation = toVisibleMessagesArray(messagesForActiveConversation)

      if (!!agentMessagesForActiveConversation.length) {
        return last(agentMessagesForActiveConversation)
      }
    }

    return null
  })

  if (lastMessageFromConversation) {
    return lastMessageFromConversation
  }

  if (lastMessageFromMessages) {
    return lastMessageFromMessages
  }

  return {}
}

export default useLastMessage
